import { render, staticRenderFns } from "./FidPhone.vue?vue&type=template&id=1ead216a&"
import script from "./FidPhone.vue?vue&type=script&lang=js&"
export * from "./FidPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports